import cx from "classnames";

import BackButton from "../../../../../src/assets/images/back-button.svg";
import ProgressBar from "../../../../shared/LinearProgressBar";

import { getTranslatedText } from "../../../../utils/getTranslatedText";

import { useGetTranslatedText } from "../../lms/queries";

import styles from "./styles.module.scss";

const HeaderModule = ({
  className,
  onBackClick,
  minutes = 30,
  seconds = 40,
  isDanger,
  current,
  total
}) => {
    const languageId = localStorage.getItem("l_id") || 1;
            
    const { data: translatedTextResponse } = useGetTranslatedText(languageId);
            
    const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <div className={styles["header-wrapper"]}>
      <img
        className={styles["back-button"]}
        src={BackButton}
        alt="back"
        onClick={onBackClick}
      />

      <div>
        <div className={cx(styles.header, className)}>
          {
                        getTranslatedText(
                          translatedText,
                          "final_assessment",
                          "Final Assessment",
                        )} 
          </div>
       <ProgressBar current={current} total={total} />
      </div>

      
        <div className={cx(styles.timer, isDanger && styles["timer-danger"])}>
          {minutes}:{seconds}
        </div>
      
    </div>
  );
};
export default HeaderModule;
